import axiosInstance from "./axiosInstance";

export const fetchTestimonials = async () => {
  try {
    const response = await axiosInstance.get("/testimonials");
    return response;
  } catch (error) {
    console.error("Erreur lors de la récupération des témoignages : ", error);
    throw error;
  }
};

export const fetchTestimonialsAdmin = async () => {
  try {
    const response = await axiosInstance.get("/testimonials/admin");
    return response;
  } catch (error) {
    console.error(
      "Erreur lors de la récupération des témoignages (admin) : ",
      error,
    );
  }
};

export const sendTestimonial = async (values) => {
  try {
    const response = await axiosInstance.post("/testimonials", values);
    return response;
  } catch (error) {
    const message = error.response?.data?.message || "Une erreur est survenue.";
    console.error("Erreur lors de l'envoi du témoignage : ", message);
    throw error;
  }
};

export const approveTestimonial = async (testimonialId) => {
  try {
    const response = await axiosInstance.post(
      `/testimonials/${testimonialId}/approve`,
    );
    return response;
  } catch (error) {
    const message = error.response?.data?.message || "Une erreur est survenue.";
    console.error("Erreur lors de la validation du témoignage : ", message);
    throw error;
  }
};

export const rejectTestimonial = async (testimonialId) => {
  try {
    const response = await axiosInstance.post(
      `/testimonials/${testimonialId}/reject`,
    );
    return response;
  } catch (error) {
    const message = error.response?.data?.message || "Une erreur est survenue.";
    console.error("Erreur lors de la non-validation du témoignage : ", message);
    throw error;
  }
};

export const deleteTestimonial = async (testimonialId) => {
  try {
    await axiosInstance.delete(`/testimonials/${testimonialId}`);
  } catch (error) {
    const message = error.response?.data?.message || "Une erreur est survenue.";
    console.error("Erreur lors de la suppression du témoignage : ", message);
    throw error;
  }
};
